export default {
    webhookLoading: false,
    webEventsListLoading: false,
    webEventsList: [],
}